document.addEventListener('DOMContentLoaded', () => {
  const openButton = document.querySelector('.register-follow #registerOpen');
  const closeButton = document.querySelector('.register-follow #registerClose');
  const infoBox= document.querySelector('.register-follow .info');

  openButton.addEventListener('click', () => {
    infoBox.classList.add('is-open');
  });
  closeButton.addEventListener('click', () => {
    infoBox.classList.remove('is-open');
  });

  document.addEventListener('click', (ev) => {
    const { target } = ev;
    const link = target.closest('.js-scroll');
    if(!link) return;
    ev.preventDefault();
    const headerHeight = document.querySelector('.navbar')?.getBoundingClientRect()?.height;
    if (!headerHeight) return;
    const elementPosition = document.querySelector(link.attributes.href.value)?.getBoundingClientRect().top;
    if (!elementPosition) return;
    const offsetPosition = elementPosition + window.scrollY - headerHeight;
  
    window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
    });
  });
}, { once: true });
